import { useMemo } from "react"

import { BlogPost } from './types'

export function useParsedEntries(entries: string): BlogPost[] {
  const parsedEntries: BlogPost[] = useMemo(() => {
    try {
      const parsed = JSON.parse(entries?.length ? entries : '[]')

      return parsed
    } catch (error) {
      console.error(error)

      return []
    }
  }, [entries])

  return parsedEntries || []
}